import { Type } from "@angular/core";
import { AnnualExpenditureChartComponent, BudgetByDepartmentChartComponent, BudgetRecapChartComponent, FiscalActivityChartComponent, MonthlyActivityChartComponent, MonthlyRevenueChartComponent, MonthlySpendingChartComponent, NextYearBudgetRecapChartComponent } from './components/charts';
import { CashBalanceByFundChartComponent } from './components';

export * from './provider';

export * from "./components";

export { IAccountModel, IGlModuleControl } from "./interfaces";

export * from "./services";

export const GL_CHART_COMPONENTS: Record<string, Type<unknown>> = {
    "GeneralLedger.AnnualExpenditureChart": AnnualExpenditureChartComponent,
    "GeneralLedger.BudgetByDepartmentChart": BudgetByDepartmentChartComponent,
    "GeneralLedger.BudgetRecapChart": BudgetRecapChartComponent,
    "GeneralLedger.NextYearBudgetRecapChart": NextYearBudgetRecapChartComponent,
    "GeneralLedger.FiscalActivityChart": FiscalActivityChartComponent,
    "GeneralLedger.MonthlyActivityChart": MonthlyActivityChartComponent,
    "GeneralLedger.MonthlyRevenueChart": MonthlyRevenueChartComponent,
    "GeneralLedger.MonthlySpendingChart": MonthlySpendingChartComponent,
    "GeneralLedger.CashBalanceByFundChart": CashBalanceByFundChartComponent
};
